import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  ResetPasswordComponent
} from '@spartacus/user/profile/components';
import { ICON_TYPE } from "../../../../../custom/icons/icon.model";
import { CustomResetPasswordComponentService } from './custom-reset-password-component.service';

@Component({
  selector: 'cx-reset-password',
  templateUrl: './custom-reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'user-form' },
  standalone: false
})
export class CustomResetPasswordComponent extends ResetPasswordComponent {
  iconTypes = ICON_TYPE;
  showPassword = false;
  showPasswordConfirm = false;

  constructor(service: CustomResetPasswordComponentService) {
    super(service);
  }

  isPasswordHidden(): void {
    this.showPassword = !this.showPassword;
  }

  isPasswordHiddenConfirm(): void {
    this.showPasswordConfirm = !this.showPasswordConfirm;
  }
}
